import {ArgValidator, ArgValidationError, ArgValidationErrorTypes} from './Utils/ArgValidator';
import {ArrayUtils} from './Utils/ArrayUtils';
import {StringUtils} from './Utils/StringUtils';
import {Utils} from './Utils/Utils';
import {Logger} from './Utils/Logger';
import {UriHelper} from './Utils/UriHelper';
import {FileUtils} from './Utils/FileUtils';
import {DateUtils} from './Utils/DateUtils';
import { StatusMessageHelper } from './Utils/StatusMessageHelper';

import * as Widgets from './Widgets/index';
import * as Pages from './Pages/index';
import * as Components from './Components/index';

export {
ArgValidator,
ArrayUtils,
StringUtils,
Utils,
FileUtils,
DateUtils,
Logger,
UriHelper,
ArgValidationError,
ArgValidationErrorTypes,

Widgets,
Pages,
Components
}

$(document).ready(() => {
    StatusMessageHelper.initValidator();
    StatusMessageHelper.initSatusMessage();
});


/** WEBPACK FOOTER **
 ** ./Typescript/App.ts
 **/